import { createSlice, type PayloadAction } from '@reduxjs/toolkit';
import { v4 as uuid } from 'uuid';

import { uniqById } from '@framework/utils/common.utils';

import type { Snackbar, SnackbarProps } from 'styled-system';

export type Snackbar = Omit<SnackbarProps, 'onDismiss'> & { onDismiss?: () => void };

type SnackbarRootState = {
    snackbars: Snackbar[];
};

const initialState: Snackbar[] = [];

const snackbarsSlice = createSlice({
    name: 'snackbars',
    initialState,
    reducers: {
        changeSnackbar: (state, action: PayloadAction<Snackbar & { id: string }>) => {
            return state.map((item) => (item.id === action.payload.id ? action.payload : item));
        },
        sendSnackbar: (state, action: PayloadAction<Snackbar>) => {
            return uniqById([{ id: uuid(), ...action.payload }, ...state]);
        },
        dismissSnackbar: (state, action: PayloadAction<string>) => {
            return state.filter((snackbar) => snackbar.id !== action.payload);
        }
    }
});

export const { changeSnackbar, sendSnackbar, dismissSnackbar } = snackbarsSlice.actions;

export const getSnackbars = (state: SnackbarRootState) => state.snackbars;

export default snackbarsSlice.reducer;
